<template>
  <div class="">
   
    <com-head :leadtext="toptext"></com-head>
    
    <div class="menu-key">
          <p class="key-text">关键词  <span>&nbsp;&nbsp;(内容由CPS中安网撰写)</span> </p>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane
              v-for="(list, index) in antarray"
              :key="index"
              :label="list.keyword"
              :name="index.index"
            >
              <div class="key-content">
                <div class="keycon-title">
                  <h3>{{ list.title }}</h3>
                  <div class="aa"></div>
                </div>
                <div v-html="list.content" id="content-style-tre"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
    </div>
    
  </div>
</template>

<script>
import comhead from "./comhead.vue";
import { trend } from "../api/api";

export default {
  components: {
    "com-head": comhead,
  },
  data() {
    return {
      toptext:
        "2020年，AI、大数据、云计算等技术与安防行业高度融合，推动智能安防的技术演变、场景应用变化等，红外测温、非接触式识别等细分场景成为新机遇，运维服务、智慧社区、市域治理等动能大幅提升。",
      antarray: [
        {
          content: "",
          create_time: 0,
          keyword: "",
          title: "",
        },
      ],
      // 关键词默认值
      activeName: "0",
      //折叠面板默认值
      activeNames: ["1"],
    };
  },
  methods: {
    //获取数据
    getData: function () {
      console.log("sds");
      var gain = {
        cate_id: 30,
        where: "[year,=,2020]",
      };
      trend(gain).then((res) => {
        this.antarray = res.data.list;
        console.log(res.data.list);
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import "../assets/public.less";
</style>
<style scoped>
.key-content >>>  p{
  text-align: justify;
  font-size: 16px;
  color: #444444;
  padding: 0px 20px;
  line-height: 30px;
}
.key-content >>> h5{
  color: #fff;
  height: 38px;
  background-color: #6F53C7;
  background-image: linear-gradient(to right, #FA1D80 , #3712B2);
  opacity: 0.7;
  margin: 0 auto;
}
.key-content >>> h5 span{
  line-height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/components/trend.vue